import React from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Card, Form, Image, List, Message, Divider, Button, Loader } from 'semantic-ui-react'
import { NotificationManager } from 'react-notifications';
import { backendService } from '../../services/backendService'
import { Link } from 'react-router-dom'
import Logo from '../../images/logo-admin.png'
import { history } from '../../store'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import RegistrationCompletePanel from './RegistrationCompletePanel'
import LawyerSelectOptions from './RegistrationDropdownOptions'
import { DEFAULT_UNSUBSCRIBED_TRIAL_DAYS, DEFAULT_TRIAL_QUERIES_COUNT } from './../../services/defaults'

const queryString = require('query-string');


const WAIT_INTERVAL = 1500;
const ENTER_KEY = 13;

const loadScript = src =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.addEventListener('load', () => {
      resolve({ successful: true })
    })
    script.addEventListener('error', event => {
      reject({ error: event })
    })
    document.head.appendChild(script)
  })

class Registration extends React.Component {
  state = {}

  constructor(props) {
    const parsed = queryString.parse(props.location.search);
    const name = parsed.name ? parsed.name : parsed.nome ? parsed.nome : '';
    const surname = parsed.surname ? parsed.surname : parsed.cognome ? parsed.cognome : '';
    const email = parsed.email ? parsed.email.toLowerCase() : parsed.mail ? parsed.mail.toLowerCase() : '';
    const origin = parsed.origin ? parsed.origin.toLowerCase() : '';
    const product_type = 'lisia_standard';
    const price_type = parsed.price_type ? parsed.price_type : 'regular';
    const trial_days = parsed.trial_days ? parsed.trial_days : DEFAULT_UNSUBSCRIBED_TRIAL_DAYS;
    const trial_queries = parsed.trial_queries ? parsed.trial_queries : DEFAULT_TRIAL_QUERIES_COUNT;
    const coupon_id =  parsed.coupon ? parsed.coupon : '';
    history.push('/registration');
    console.log( 'origin: ' + origin );
    super(props)
    this.state = {
      loading: false,
      registration_successfull: false,
      processing: false,
      is_registered: false,
      was_registered: false,
      lawyer_type: null,
      terms_accepted: false,
      price_type: price_type,      
      product_type: product_type,     
      product_prices : [],
      name: name,
      surname: surname,
      email: email,
      coupon_id: coupon_id,
      password: '',      
      amount: 0,
      currency: '',
      trial_days: trial_days,
      trial_queries: trial_queries,
      origin: origin,
      errors: {        
        name: '',
        email: '',
        query: '',        
        password: '',
        surname: '',
        lawyer_type: '',
        terms_accepted: ''
      }
    };
    if (email && email.length > 0)
      this.timer = setTimeout(this.triggerEmailChange.bind(this), WAIT_INTERVAL);
    this.validateUser = this.validateUser.bind(this);
    
  } 

  componentWillMount() {
    this.timer = null;
    
  }

  componentDidMount () {    
    
    window.dataLayer.push({
      event: 'page_view',
      page: {
        url: document.location.pathname,
        title: 'Registration'
      }
    });
    
    sessionStorage.clear();
  }
 
  handleSubmit = async (evt) => {
    try {
      this.setState({processing: true});
      evt.preventDefault();    
      //check data and requirements
      const validateErrors = await this.validateUser();
      if (validateErrors) {
        this.setErrors(validateErrors);
      }
      let allOk = !validateErrors;
      //proceed with the registration
      if (allOk) {   
        await this.createCustomer();
      } 
      this.setState({processing: false});
    } catch (exc) {
      this.setState({processing: false});
    }
  };

  validateUser = async () => {
    const fieldsErrors = {};
    if (!this.state.terms_accepted) fieldsErrors.terms_accepted = Translate(this.context,'signup_terms_required')
    if (!this.state.lawyer_type) fieldsErrors.lawyer_type = Translate(this.context,'signup_lawyer_type_is_required')
    if (this.state.name === '') fieldsErrors.name = Translate(this.context,'signup_name_is_required')
    if (this.state.surname === '') fieldsErrors.surname = Translate(this.context,'signup_surname_is_required')
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/.test(this.state.email)) fieldsErrors.email = Translate(this.context,'signup_email_is_invalid')
    if (this.state.email === '') fieldsErrors.email = Translate(this.context,'signup_email_is_required')
    if (this.state.password === '') fieldsErrors.password = Translate(this.context,'signup_password_is_required')
        else {
      const response = await backendService.get(`/api/users/exists?email=${this.state.email}`)
      if (response && response.data) {
        const isUser = response.data.exists
        if (isUser)
          fieldsErrors.email = Translate(this.context,'email_in_use')
      }
    }    
    return Object.keys(fieldsErrors).length ? fieldsErrors : false;
  }

  setErrors(errors) {
    this.setState({errors})
  }

  async createCustomer() {
    
    //send registration button pressed event
    window.dataLayer.push({
      event: 'user_event',
      eventProps: {
        category: 'user_action',
        action: 'registration_button_pressed',
        label: 'Registration Button Pressed',
        value: 'true'
    }
    });

    this.setState({processing: true})
    let validateErrors = await this.validateUser();
    if (validateErrors) {
      this.setState({errors: validateErrors})
    } else {
      const { name, surname, email, password } = this.state;
      const work_area = this.state.lawyer_type;
      const desired_plan_id =  '';
      const trial_queries_count = this.state.was_registered ? 0 : this.state.trial_queries;
      const trial_days_count = this.state.was_registered ? 0 : this.state.trial_days;
      const origin = this.state.origin;

      let req = { name, 
                  surname, 
                  email, 
                  password, 
                  work_area, 
                  price_type: 
                  this.state.price_type, 
                  is_returning: this.state.was_registered, 
                  desired_plan_id, 
                  trial_queries_count, 
                  trial_days_count,
                  origin };

      try {        
          const resp = await backendService.post('/api/lawyers', req)
          if (resp && resp.data && resp.data.email)
            this.setState({processing: false, registration_successfull: true});
          else {            
            this.setState({processing: false, error: true})         
            const mess = Translate(this.context, 'signup_failed');
            NotificationManager.error(mess);
          }
          
      } catch(error) {
        this.setState({ processing: false, error: true})
        const mess = Translate(this.context, 'signup_failed');
        NotificationManager.error(mess);        
      }
    }
    this.setState({processing: false})
    
  }

 handlePasswordChange(event) {
    if (event.target.value === '')
      this.setState({errors: {...this.state.errors, password: Translate(this.context,'signup_password_is_required')}})
    else
      this.setState({errors: {...this.state.errors, password: ''}})
    this.setState({password: event.target.value});
  }

  handleEmailChange(event) {  
    clearTimeout(this.timer);
    this.setState({ email: event.target.value.toLowerCase() });
    this.timer = setTimeout(this.triggerEmailChange.bind(this), WAIT_INTERVAL); 

  }

  handleKeyDown(e) {    
    if (e.keyCode === ENTER_KEY) {
        this.triggerEmailChange();
    }
  } 

  onTermsLinkClicked = (e) => {
    e.preventDefault();
  }

  async triggerEmailChange() {
    const email = this.state.email    
    
    let email_error = ''
    if (email) {
      const response = await backendService.get(`/api/users/exists?email=${email}`)
      if (response && response.data) {
        const isUser = response.data.exists
        if (isUser) {
          email_error = Translate(this.context,'email_in_use')
          this.setState({is_registered: true})
        } else {
          this.setState({is_registered: false}) 
        }
      }
      if (!this.state.is_registered) {
        const was_response = await backendService.get(`/api/users/existed?email=${email}`)
        if (was_response && was_response.data) {
          const wasUser = was_response.data.existed
          if (wasUser) {            
            this.setState({was_registered: true})                
          } else {
            this.setState({was_registered: false})            
          }
        }
      }
    } else {
      this.setState({is_registered: false})
      this.setState({was_registered: false})      
      email_error= Translate(this.context,'signup_email_is_required')
    }    
    this.setState({errors: {...this.state.errors, email: email_error}})    
    this.setState({email: email}); 
  }


  handleNameChange(event) {
    if (event.target.value === '')
      this.setState({errors: {...this.state.errors, name: Translate(this.context,'signup_name_is_required')}})
    else
      this.setState({errors: {...this.state.errors, name: ''}})
    this.setState({name: event.target.value});
  }

  handleLastNameChange(event) {
    if (event.target.value === '')
      this.setState({errors: {...this.state.errors, surname: Translate(this.context,'signup_surname_is_required')}})
    else
      this.setState({errors: {...this.state.errors, surname: ''}})
    this.setState({surname: event.target.value});
  }

  handleLawyerChange(event , { value }) {
    this.setState({lawyer_type: value});
  }

  handleTermsChange() {
    this.setState({terms_accepted: !this.state.terms_accepted});
  }
  
  handleChange = (e, { value }) => {
    this.setState({errors: {...this.state.errors/*, plan: ''*/}})
    //this.setState({plan: value })
  }
  
  render() {  
    const { name, surname, email, password } = this.state
    return (
      this.state.registration_successfull ? <RegistrationCompletePanel email={this.state.email} signup_warning_message={this.state.signup_warning_message} /> :
      <div className="registration lisia-dialog lisia-centered-dialog">
        <Row center="xs" >          
              <Col className='registration-wrapper' xs={11} sm={9} md={7} lg={5}>
                <Card fluid={true} raised={true} centered={true}>
                  <Card.Content>
                    <div className="registrationForm">
                      <Image size='small' src={ Logo } className='m-b-50'/>
                      { this.state.loading === true ? 
                          <Loader active inline='centered' className='marginLoadMore' />
                        :                          
                        <>
                          <Form onSubmit={this.registrate}>
                            <h1 className='text-center'><Text tid='signup_account_information' /></h1>         
                            <Divider />
                            <Form.Group widths='equal'>
                              <Form.Input 
                                autoComplete="first-name"
                                value={name} 
                                onChange={this.handleNameChange.bind(this)} 
                                placeholder={Translate(this.context,'user_profile_first_name')}
                                error={this.state.errors.name !== '' ? this.state.errors.name : false}
                              />
                            </Form.Group>
                            <Form.Group widths='equal'>                          
                              <Form.Input 
                                autoComplete="family-name"
                                value={surname}
                                error={this.state.errors.surname !== '' ? this.state.errors.surname : false}
                                onChange={this.handleLastNameChange.bind(this)} 
                                placeholder={Translate(this.context,'user_profile_last_name')}
                              />
                            </Form.Group>
                            <Form.Group widths='equal' >     
                              <Form.Select
                                fluid
                                options={LawyerSelectOptions[this.state.price_type] ? LawyerSelectOptions[this.state.price_type] : LawyerSelectOptions['regular']}
                                placeholder={Translate(this.context,'signup_select_an_option')}
                                onChange={this.handleLawyerChange.bind(this)}
                                error={this.state.errors.lawyer_type !== '' ? this.state.errors.lawyer_type : false}
                              />                                 
                            </Form.Group>
                            <Form.Group widths='equal'>
                              <Form.Input 
                                autoComplete="email"
                                value={email} 
                                onChange={this.handleEmailChange.bind(this)} 
                                placeholder={Translate(this.context,'user_profile_email')}
                                error={this.state.errors.email !== '' ? this.state.errors.email : false}
                                onKeyDown={this.handleKeyDown.bind(this)}
                              />
                              </Form.Group>
                            <Form.Group widths='equal'>
                              <Form.Input 
                                value={password} 
                                onChange={this.handlePasswordChange.bind(this)} 
                                placeholder={Translate(this.context,'pick_a_password')} 
                                type="password"
                                error={this.state.errors.password !== '' ? this.state.errors.password : false} 
                              />
                            </Form.Group>
                            { this.state.was_registered &&
                                <Message                              
                                  content={Translate(this.context,'user_was_registered')}
                                />
                            }                            
                          </Form>    
                          { this.state.errors.terms_accepted &&
                                <Message
                                  negative
                                  header={this.state.errors.terms_accepted}
                                />
                            }
                          <Form.Group > 
                            <Form.Checkbox onChange={this.handleTermsChange.bind(this)} 
                              checked={this.state.terms_accepted} 
                              className='accept_terms-checkbox' 
                              label={<label>Ho letto ed accetto le <a className='terms-link' target='_blank' href='https://www.lisia.it/termini-e-condizioni?lang=it' onClick='onTermsLinkClicked'> condizioni d'uso</a></label>}                               
                              error={this.state.errors.terms_accepted !== '' ? true : false} 
                            />
                          </Form.Group>                      
                          <Button disabled={  this.state.buttonDisabled || this.state.processing } 
                                  className='lisia-blue sign-up-button' 
                                  type='submit'
                                  onClick={this.handleSubmit}
                          >
                            <Text tid='signup'/>
                          </Button>       
                          <Divider />                          
                          <div className="footer">
                            <Link to='/login' style={{float: 'left'}}>
                              <Text tid="go_to_login" />
                            </Link>                      
                          </div>
                        </>
                      }
                    </div>
                  </Card.Content>
                </Card>
              </Col>        
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  stripeState: state.stripeState,
  auth: state.auth,
})

export default connect(mapStateToProps)(Registration)

Registration.contextType = LanguageContext;
